/*
* @author 友人a丶
* @date 
* 
* */

export default {
    "primary-color": '#fa541c'
}